import mainMessages from "../i18n/main/fr.json";
import settingsMessages from "../i18n/settings/fr.json";
import affinityMessages from "../i18n/affinity/fr.json";
import coordinatorMessages from "../i18n/coordinator/fr.json";

const saLang = {
  messages: {
    ...mainMessages,
    ...affinityMessages,
    ...settingsMessages,
    ...coordinatorMessages,
  },
  locale: "fr",
};
export default saLang;
